'use strict';

module.exports = '2.20.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 305
// module chunks = 0